import { render, staticRenderFns } from "./QueryResult.vue?vue&type=template&id=ac142064&scoped=true"
import script from "./QueryResult.vue?vue&type=script&lang=js"
export * from "./QueryResult.vue?vue&type=script&lang=js"
import style0 from "./QueryResult.vue?vue&type=style&index=0&id=ac142064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac142064",
  null
  
)

export default component.exports